"use client"

import { Divider } from "@chakra-ui/react"
import { accountNavigationConfig } from "config/navigation"
import type React from "react"
import DropdownLinkItem from "../components/DropdownLinkItem"
import SignOutButton from "../components/SignOutButton"

export const AccountPopoverLinks: React.FC<{ isLoading?: boolean }> = ({ isLoading }) => {
    return (
        <section
            className='relative flex w-full flex-col items-start justify-start dark:text-gray-200'
            id='base-nav-links'
        >
            {accountNavigationConfig.map((item, i) => (
                <DropdownLinkItem item={item} key={`${item.application}_${item.path}`} />
            ))}
            <Divider borderBottomColor='gray.100' _dark={{ borderBottomColor: "gray.500" }} />
            <SignOutButton />
        </section>
    )
}

export default AccountPopoverLinks
